<!-- Transactions: list with filters (text, type, year) and export in the common format. -->
<script lang="ts">
  import type { Tx } from "../core/types";
  import { app, need, type UiState } from "../lib/state.svelte";
  import { download, openInstrument, toCsv } from "../lib/actions";
  import { fmtDate, fmtNum, signCls } from "../lib/format";
  import { TYPE_PL } from "../lib/holdings";
  import ViewHead from "../components/ViewHead.svelte";
  import Card from "../components/Card.svelte";

  const m = $derived(need(app.model));
  const S = $derived(new Set(app.accList));
  const f = $derived(app.ui.txf || {});
  const years = $derived([...new Set(m.txs.map((t) => t.day.slice(0, 4)))].sort().reverse());
  const list = $derived(m.txs.filter((t) => S.has(t.account)
    && (!f.type || t.type === f.type) && (!f.year || t.day.startsWith(f.year))
    && (!f.q || `${t.symbol} ${t.name} ${t.note} ${t.id}`.toLowerCase().includes(f.q.toLowerCase()))).slice().reverse());
  const total = $derived(m.txs.filter((t) => S.has(t.account)).length);
  const shown = $derived(list.slice(0, 1500));
  const noLink = "javascript:void 0";

  type TxFilter = NonNullable<UiState["txf"]>;
  const upd = (k: keyof TxFilter, v: string) => { app.ui.txf = { ...(app.ui.txf || {}), [k]: v }; };

  function exportCsv() {
    const cols = ["id", "datetime", "account", "broker", "type", "symbol", "isin", "name", "asset_class", "quantity", "price", "price_currency", "amount", "currency", "fee", "tax", "cost_basis", "acquired", "transfer_id", "counterparty", "note", "source"];
    download("transakcje_ptf.csv", toCsv<Tx>(list.slice().reverse(), cols.map((k) => ({ k }))));
  }
</script>

<ViewHead title="Transakcje" sub="{list.length} z {total}" />
<div class="row"><input type="search" id="txq" placeholder="Szukaj (symbol, nazwa, opis)" value={f.q || ""} style="min-width:240px" onchange={(ev) => upd("q", ev.currentTarget.value)} />
  <select id="txtype" onchange={(ev) => upd("type", ev.currentTarget.value)}><option value="">Wszystkie typy</option>{#each Object.entries(TYPE_PL) as [k, v] (k)}<option value={k} selected={f.type === k}>{v}</option>{/each}</select>
  <select id="txyear" onchange={(ev) => upd("year", ev.currentTarget.value)}><option value="">Wszystkie lata</option>{#each years as y (y)}<option selected={f.year === y}>{y}</option>{/each}</select>
  <span class="spacer"></span><button class="btn" id="expTx" onclick={exportCsv}>Eksport CSV (wspólny format)</button></div>
<Card title="">
  <div class="table-wrap"><table><thead><tr><th class="l">Data</th><th class="l">Rachunek</th><th class="l">Typ</th><th class="l">Instrument</th><th>Ilość</th><th>Cena</th><th>Kwota</th><th>PLN</th><th>Prowizja</th><th class="l">Opis</th></tr></thead><tbody>
    {#each shown as t, n (n)}
      {@const pl = t.amt * m.fx(t.currency, m.idx(t.day))}
      {@const key = m.instr[t.symbol]?.key}
      <tr><td class="l">{fmtDate(t.day)} <span class="muted small">{t.datetime.slice(11, 16)}</span></td><td class="l">{t.account}</td><td class="l">{TYPE_PL[t.type] || t.type}</td>
        <td class="l">{#if t.symbol}<a href={noLink} data-key={key ?? ""} onclick={() => openInstrument(key ?? "")}>{t.symbol}</a> <span class="muted small">{m.instr[t.symbol]?.name || ""}</span>{/if}</td>
        <td>{t.qty ? fmtNum(t.qty, t.qty % 1 ? 4 : 0) : ""}</td><td>{t.price ? `${fmtNum(t.price, 3)} ${t.priceCcy}` : ""}</td><td>{#if t.amt}<span class="money {signCls(t.amt)}">{fmtNum(t.amt, 2)} {t.currency}</span>{/if}</td>
        <td>{#if t.amt && t.currency !== "PLN"}<span class="money">{fmtNum(pl, 2)}</span>{/if}</td><td>{t.fee ? fmtNum(t.fee, 2) : ""}</td><td class="l small muted" title={t.note ?? ""}>{(t.note || "").slice(0, 60)}</td></tr>
    {/each}
  </tbody></table></div>
  {#if list.length > 1500}<p class="small muted">Pokazano 1500 najnowszych — zawęź filtry.</p>{/if}
</Card>
